module.exports = __webpack_public_path__ + "img/metal_d@2x.89763c5d.png";